import React from "react";
import Home from "./Home";
import Dashboard from "./Dashboard";

const Dash_Home = () => {
  return (
    <>
      <Dashboard />
      <Home />
    </>
  );
};

export default Dash_Home;
